import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>The simplest daily chat</h1>
			<p className='project-popup__description '>
				Earlier, I created a couple of web chats using web sockets and Node.js. But I
				decided to create a simple chat application using PHP & AJAX for fun and
				practice. As for me, it turned out catchy :)
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						PHP, MySQL, Design, HTML, CSS, JavaScript, Ajax
					</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/chat/main.webp',
						backupImage: './media/projects/chat/main.jpg',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='chat-image1' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/chat/1.webp',
						backupImage: './media/projects/chat/1.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='chat-image2' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
